import {Component, OnInit} from '@angular/core';
import {LogbookService} from '../../../../services/logbook.service';
import * as moment from 'moment';
import { StationService } from '../../../../services/stations.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'ngx-logbooks-indicators',
  templateUrl: './logbooks-indicators.component.html',
  styleUrls: ['./logbooks-indicators.component.scss'],
})
export class LogbooksIndicatorsComponent implements OnInit {
  stationId: string;
  loading = false;
  indicatorsData = [];
  selected = moment().year();
  total = 0;
  years = [];
  range = {
    startDate: moment().startOf('year'),
    endDate: moment().endOf('year'),
  };

  constructor(
    private logbookService: LogbookService,
    private stationService: StationService,
    private route: ActivatedRoute,
  ) {
    this.stationId =  this.route.snapshot.params.stationId;

    this.stationService.change.subscribe(async (station: any) => {
      this.stationId = station;
      this.init();
    });
  }

  async ngOnInit() {
    this.init()
  }

  async init() {
    this.loading = true;
    const currentYear = moment().year()
    for (let index = 0; index < 6; index++) {
      this.years.push(currentYear - index)
    }
    await this.getLogbooks();
    this.loading = false;
  }

  async getLogbooks() {
    this.total = 0;
    this.indicatorsData = [];
    const [error, result]: any = await this.logbookService.getIndicatorsStation(this.stationId, this.range);
    if (error) return console.error(error);

    for (const resultLogbook of result.data) {
      this.total += resultLogbook.total;
      if (resultLogbook.type === 1) this.indicatorsData.push({ name: 'Mantenimientos', total: resultLogbook.total, logo: '../../../../../assets/icons/repair-tools.png' });
      if (resultLogbook.type === 2) this.indicatorsData.push({ name: 'Accidentes e incidentes', total: resultLogbook.total, logo: '../../../../../assets/icons/caution-sign.png' });
      if (resultLogbook.type === 3) this.indicatorsData.push({ name: 'Recepción y descarga', total: resultLogbook.total, logo: '../../../../../assets/icons/risk.png' });
      if (resultLogbook.type === 4) this.indicatorsData.push({ name: 'Desviaciones en el balance del producto', total: resultLogbook.total, logo: '../../../../../assets/icons/gas.png' });
      if (resultLogbook.type === 5) this.indicatorsData.push({ name: 'Revisión de baterías', total: resultLogbook.total, logo: '../../../../../assets/icons/battery.png' });
      if (resultLogbook.type === 6) this.indicatorsData.push({ name: 'Bitácora de eventos', total: resultLogbook.total, logo: '../../../../../assets/icons/booking.png' });
      if (resultLogbook.type === 7) this.indicatorsData.push({ name: 'Residuos peligrosos', total: resultLogbook.total, logo: '../../../../../assets/icons/waste.png' });
      if (resultLogbook.type === 8) this.indicatorsData.push({ name: 'Limpieza de sitios contaminados', total: resultLogbook.total, logo: '../../../../../assets/icons/contamination.png' });
      if (resultLogbook.type === 9) this.indicatorsData.push({ name: 'Extintores', total: resultLogbook.total, logo: '../../../../../assets/icons/fire-extinguisher.png' });
      if (resultLogbook.type === 10) this.indicatorsData.push({ name: 'Limpiezas programadas y no programadas', total: resultLogbook.total, logo: '../../../../../assets/icons/cleaner.png' });
      if (resultLogbook.type === 11) this.indicatorsData.push({ name: 'Hermeticidad', total: resultLogbook.total, logo: '../../../../../assets/icons/oil-valve.png' });
      if (resultLogbook.type === 12) this.indicatorsData.push({ name: 'Incidentes e inspecciones', total: resultLogbook.total, logo: '../../../../../assets/icons/search.png' });
    }
  }

  async calculateDate() {
    this.range.startDate = await moment(`01-01-${this.selected}`).startOf('year');
    this.range.endDate = await moment(`01-01-${this.selected}`).endOf('year');
    return this.ngOnInit();
  }

}
